import React, { useEffect, useState } from 'react'
import './RegisterAccelerator.scss'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import OnboardingHeader from '../Header/AcceleratorHeader/OnboardingHeader'
import { Button } from 'react-bootstrap'
import { GoogleLogin } from '@react-oauth/google'
import { Checkbox, Divider, Input, Button as AntButton, message } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Label } from 'reactstrap'
import { acceleratorGoogleSignup, acceleratorSignup } from '../../redux/auth/authActions'
import { nameRegxCheck } from '../../utils/general'

// Functional component for the Startup login page.
const RegisterAccelerator = ({ history, authLoading, acceleratorSignup, acceleratorGoogleSignup }) => {
  const [data, setData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    hidden: true,
    fieldError: { first_name: '', last_name: '' },
    error: '',
  })

  const handleChange = e => {
    const { name, value } = e.target
    if (name === 'first_name' || name === 'last_name') {
      if (!nameRegxCheck(value)) {
        return
      }
    }
    setData(prev => ({
      ...prev,
      [name]: value,
    }))
  }
  console.log({ data })

  const acceleratorOnClick = () => {
    acceleratorSignup(
      {
        first_name: data?.first_name?.trim(),
        last_name: data?.last_name?.trim(),
        email: data?.email?.trim(),
        password: data?.password?.trim(),
      },
      res => {
        if (res.result) {
          history.push('/accelerator/onboarding/step-1')
        } else {
          //   message.error(res?.error)
          let parsedStatus
          if (res?.error === 'email exists') {
            parsedStatus = 'That email is already in use. Please log in.'
          } else if (res?.error === 'invalid email') {
            parsedStatus = 'Invalid email'
          } else {
            parsedStatus = 'An unknown error occurred; please try again and/or contact us.'
          }
          setData(prev => ({
            ...prev,
            error: parsedStatus,
          }))
        }
      },
      err => {
        let parsedStatus
        if (err === 'email exists') {
          parsedStatus = 'That email is already in use. Please log in.'
        } else if (err === 'invalid email') {
          parsedStatus = 'Invalid email'
        } else {
          parsedStatus = 'An unknown error occurred; please try again and/or contact us.'
        }
        setData(prev => ({
          ...prev,
          error: parsedStatus,
        }))
      },
    )
  }
  const isSubmitEnabled = () => {
    const validEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/

    const { first_name, last_name, email, password } = data
    if (
      first_name?.length > 0 &&
      last_name?.length > 0 &&
      validEmail.test(email) &&
      password?.length >= 8 &&
      !data?.fieldError?.first_name &&
      !data?.fieldError?.last_name
    ) {
      return true
    }
    return false
  }
  const isEnabled = isSubmitEnabled()
  const toggleAlert = () => {
    setData(prev => ({
      ...prev,
      error: '',
    }))
  }
  const acceleratorGoogleOnClick = googleUser => {
    acceleratorGoogleSignup(
      googleUser,
      res => {
        if (res.result) {
          history.push('/accelerator/onboarding/step-1')
        } else {
          //   message.error(res?.error)
          let parsedStatus
          if (res?.error === 'email exists') {
            parsedStatus = 'That email is already in use. Please log in.'
          } else if (res?.error === 'invalid email') {
            parsedStatus = 'Invalid email'
          } else {
            parsedStatus = 'An unknown error occurred; please try again and/or contact us.'
          }
          setData(prev => ({
            ...prev,
            error: parsedStatus,
          }))
        }
      },
      err => {
        let parsedStatus
        if (err === 'email exists') {
          parsedStatus = 'That email is already in use. Please log in.'
        } else if (err === 'invalid email') {
          parsedStatus = 'Invalid email'
        } else {
          parsedStatus = 'An unknown error occurred; please try again and/or contact us.'
        }
        setData(prev => ({
          ...prev,
          error: parsedStatus,
        }))
      },
    )
  }

  const acceleratorGoogleSignupFailure = (errorCode, errorDetails) => {
    // emitStartupSignupFailed(true, errorCode, errorDetails)
    // Do something here
  }
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://exitfund.com/accelerator/signup" />
      </Helmet>
      <OnboardingHeader />
      <div className="signup-section">
        <h3>accelerator Sign up</h3>
        <div className="signup-with-google">
          <GoogleLogin
            cookiePolicy={'single_host_origin'}
            onSuccess={googleUser => {
              acceleratorGoogleOnClick(googleUser)
            }}
            onError={({ error, details }) => {
              acceleratorGoogleSignupFailure(error, details)
            }}
            width="300px"
            text="signup_with"
          />
        </div>
        <Divider>Or</Divider>
        <form>
          {data.error && (
            <p className={data.error ? 'sign-up-error' : 'close'}>
              {data.error}
              <CloseCircleOutlined onClick={toggleAlert} className="float-right" />
            </p>
          )}
          <div className="form-field">
            <Label>Your First Name</Label>
            <Input
              className="text-field-input"
              placeholder="Steve"
              name="first_name"
              type="text"
              onChange={handleChange}
              value={data?.first_name}
            />
            {data?.fieldError?.first_name && <p className="text-danger">{data?.fieldError?.first_name}</p>}
          </div>
          <div className="form-field">
            <Label>Your Last Name</Label>
            <Input
              className="text-field-input"
              placeholder="Jobs"
              name="last_name"
              type="text"
              onChange={handleChange}
              value={data?.last_name}
            />
            {data?.fieldError?.last_name && <p className="text-danger">{data?.fieldError?.last_name}</p>}
          </div>
          <div className="form-field">
            <Label>Email Address</Label>
            <Input
              className="text-field-input"
              placeholder="stevejobs@gmail.com"
              name="email"
              type="text"
              onChange={handleChange}
              value={data?.email}
            />
          </div>
          <div className="form-field" style={{ position: 'relative' }}>
            <Label>Password (at least 8 characters)</Label>
            <Input
              className="text-field-input"
              placeholder="•••••••••"
              name="password"
              type={data?.hidden ? 'password' : 'text'}
              onChange={handleChange}
              value={data?.password}
            />
            <i
              className={
                data?.hidden
                  ? 'fa fa-eye 3x passing-line-through register-password-icon'
                  : 'fa fa-eye-slash 3x passing-line-through register-password-icon'
              }
              style={{
                bottom: '23%',
                position: 'absolute',
              }}
              onClick={() =>
                setData(prev => ({
                  ...prev,
                  hidden: !data.hidden,
                }))
              }
            />
          </div>
          <span className="agreement-policy">
            By signing up, I agree to Exitfund's{' '}
            <Link to="/termsofservice" target="_blank" rel="noopener noreferrer">
              terms, conditions
            </Link>{' '}
            and{' '}
            <Link to="/policy" target="_blank" rel="noopener noreferrer">
              privacy policy.
            </Link>{' '}
          </span>
          <AntButton
            loading={authLoading}
            disabled={!isEnabled}
            onClick={acceleratorOnClick}
            className="sign-in"
          >
            Sign up
          </AntButton>
        </form>
        <p className="dont-have-acc">
          <Link to="/accelerator/login">Already have an account? Log in</Link>
        </p>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  authLoading: state?.auth?.loading,
})

const mapDispatchToProps = dispatch => ({
  acceleratorSignup: (data, onSuccess, onFail) => dispatch(acceleratorSignup(data, onSuccess, onFail)),
  acceleratorGoogleSignup: (googleUser, onSuccess, onFail) =>
    dispatch(acceleratorGoogleSignup(googleUser, onSuccess, onFail)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RegisterAccelerator)
